class CopyLinks {
  copyInviteLink() {
    console.log("copyInviteLink FUNCTION CALLED");
    var inviteLink = document.getElementById("invite_link");
    inviteLink.focus();
    inviteLink.setSelectionRange(0, 99999);
    document.execCommand("copy");
    alert("Invite link copied!");
  }
  copyShareLink() {
    console.log("copyShareLink FUNCTION CALLED");
    var shareLink = document.getElementById("share_link");
    shareLink.focus();
    shareLink.setSelectionRange(0, 99999);
    document.execCommand("copy");
    $(share_modal).modal("hide");
  }
  copyBooleanKeywordsLink() {
    var shareLink = document.getElementById("boolean_keywords_modal_textarea");
    shareLink.focus();
    shareLink.setSelectionRange(0, 99999);
    document.execCommand("copy");
    $(boolean_keywords_modal).modal("hide");
  }
  copySignupInviteLink() {
    console.log("copySignupInviteLink FUNCTION CALLED");
    var inviteLink = document.getElementById("signup_invite_link");
    inviteLink.focus();
    inviteLink.setSelectionRange(0, 99999);
    document.execCommand("copy");
    alert("Invite link copied!");
  }
}

class UploadJDCVTopBar {
  changeUploadJDCV(user_input) {
    var upload_type = user_input.getAttribute("upload_type");
    var label = user_input.getAttribute("label");
    document.getElementById("pick_upload_jd_cv_error").innerHTML = "";
    document.getElementById("upload_jd_cv_dropdown_selected").innerHTML = label;
    sessionStorage["upload_type_jd_cv"] = upload_type;
  }
  uploadJDCV() {
    console.log("uploadJD FUNCTION CALLED");
    $(upload_jdcv_modal).modal("show");
  }
  uploadJD() {
    console.log("uploadJD FUNCTION CALLED");
    $(upload_jd_modal).modal("show");
  }
  uploadJDAjaxtoFlask() {
    // var form_data = new FormData();
    // form_data.append('file', $('#upload-file').prop('files')[0]);
    if (sessionStorage["upload_type_jd_cv"] == "") {
      document.getElementById("pick_upload_jd_cv_error").innerHTML = '<span style="color:red">Please select upload type</span>';
    } else {
      var form_data = new FormData($("#upload-file")[0]);
      if (document.getElementById("upload-file")[0].files.length == 0) {
        console.log("Please select a file");
        document.getElementById("pick_upload_jd_cv_error").innerHTML = '<span style="color:red">Please upload a ' + sessionStorage["upload_type_jd_cv"] + "</span>";
      } else {
        console.log("File has been selected");
        if (sessionStorage["upload_type_jd_cv"] == "jd") {
          var upload_path = "/uploadJD";
        } else {
          var upload_path = "/uploadCV";
        }
        $.ajax({
          type: "POST",
          url: upload_path,
          data: form_data,
          contentType: false,
          cache: false,
          processData: false,
          error: function (xhr, status) {
            var error_status = xhr.status;
            if (error_status == 599) {
              new PageContents().tokenExpireAction();
            } else {
              document.getElementById("pick_upload_jd_cv_error").innerHTML = '<span style="color:red">Some error. Please refresh and try again or contact support</span>';
            }
          },
          success: function (data) {
            sessionStorage["upload_type_jd_cv"] = "";
            console.log("Success!");
            console.log("This is the data received::", data);
            console.log("Hiding modal jd cv upload!");
            document.getElementById("pick_upload_jd_cv_error").innerHTML = '<span style="color:green">Success! File Uploaded</span>';
            $(upload_jdcv_modal).modal("hide");
            new UploadJDCVTopBar().fetchCandidatesfromUploadJDCV(data, upload_path);
          },
        });
      }
    }
  }
  onChangeFileUploadJd() {
    document.getElementById("upload_new_jd_form_err").innerHTML = "";
  }
  async uploadJDToFlask() {
    let loder_err_element = document.getElementById("upload_new_jd_form_err");
    if (loder_err_element.innerHTML == "") {
      let loader = '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/>';
      loder_err_element.innerHTML = loader;
      const fileInput = document.getElementById("upload_new_jd_file_input");
      const file = fileInput.files[0];
      if (file) {
        let post_request_url = base_url + "/upload_jd";
        let job = null;
        if (!!sessionStorage["current_job"]) {
          job = JSON.parse(sessionStorage["current_job"]);
        }
        let formdata = new FormData();
        formdata.append("file", file);
        if (job?.job_id && job?.job_name) {
          formdata.append("job_id", job["job_id"]);
          formdata.append("job_name", job["job_name"]);
        }
        try {
          const response = await fetch(post_request_url, {
            method: "POST",
            body: formdata,
          });
          let data = await response.json();
          console.log("Response sendChatToBackendGetResponse:", data);
          if (data["status"] === "success") {
            console.log("received data successfully. this is the data::", data);
            loder_err_element.innerHTML = "";
          }
          $(upload_jd_modal).modal("hide");
          new ListPageElements().createAllJobsListings();
        } catch (error) {
          console.log("have caughgt an error bosssss");
          if (error.message.includes("signed out")) {
            new PageContents().tokenExpireAction();
          } else {
            loder_err_element.innerHTML = '<span style="color:red">Some error. Please refresh and try again or contact support</span>';
            console.log("Error:", error);
          }
        }
      } else {
        console.log("Please select a file");
        loder_err_element.innerHTML = '<span style="color:red">Please upload a JD</span>';
      }
    }
  }
  fetchCandidatesfromUploadJDCV(data, upload_path) {
    console.log("Got data from fetchCandidatesfromUploadJDCV", data);
    console.log("Got path from fetchCandidatesfromUploadJDCV", upload_path);
    token_obj = data["results"]["data"]["modified_query_results"];
    console.log("token_obj");
    updateStorageToken(token_obj, "fetchCandidatesfromUploadJDCV");
    new Toggle().togglePeople();
  }
}

class TablesPageComponents {
  updateNewTableNameUserInput(user_input) {
    sessionStorage["selected_create_new_sublist_candidates"] = JSON.stringify({ new_table_name: document.getElementById("enter_sublist_modal_input").value });
  }

  viewTableinOrgChart() {
    console.log("Hit the viewTableinOrgChart function");
    new ProcessNodesStates().resetSessionStorageforDropdowns();
    updateStorageToken({}, "viewTableinOrgChart");
    new Toggle().toggleOrgCharts();
  }
  setupRightPanelSublists() {
    console.log("Loading right panel with sublists");
    var sublist_element = document.getElementById("sublist_element").innerHTML;
    console.log("Current table id in quertinos::", JSON.parse(sessionStorage["current_table"])["table_id"]);
    console.log("Current table querton::", JSON.parse(sessionStorage["current_table"]));
    var current_sublists = [];
    var all_jobs = JSON.parse(sessionStorage["all_jobs"]);
    // debugger;
    console.log("All jobs is ::: ", all_jobs);
    for (var i = 0; i < all_jobs.length; i++) {
      for (var j = 0; j < all_jobs[i]["sublists"]?.length; j++) {
        if (all_jobs[i]["sublists"][j]["sublist_id"] == JSON.parse(sessionStorage["current_table"])["table_id"]) {
          current_sublists = all_jobs[i]["sublists"];
          break;
        }
      }
    }
    console.log("All current_sublists is ::", current_sublists);
    var all_sublist_elements = "";
    // all_sublist_elements = []
    for (var i = 0; i < current_sublists.length; i++) {
      var updated_sublist_element = sublist_element.replaceAll("{job_id}", current_sublists[i]["sublist_id"]).replaceAll("{job_name}", current_sublists[i]["sublist_name"]);
      all_sublist_elements = all_sublist_elements + updated_sublist_element;
    }
    console.log("Setting up sublists is complete");
    document.getElementById("right_panel_sub").innerHTML = all_sublist_elements;
  }
  setupTableName(table_name) {
    var table_name = JSON.parse(sessionStorage["current_table"])["table_name"];
    document.getElementById("current_job_name").innerHTML = new UtilityFunctions().truncateString(table_name, 25);
  }

  selectThisTable(user_input) {
    console.log("This is the selectd user table::", user_input);
    var job_id_selected = user_input.getAttribute("job_id");
    var job_name_selected = user_input.getAttribute("job_name");
    console.log("This is the table selected:::", job_id_selected);
    console.log("Setting current table here:::");
    sessionStorage["current_table"] = JSON.stringify({
      table_id: job_id_selected,
      table_name: job_name_selected,
    });
    new PageContents().changePage("/tables");
    this.setupRightPanelSublists();
  }

  selectThisJob(user_input) {
    console.log("This job got selected");
    new Toggle().setHeadlineLeftPanelUnderLineTabs("lists");
    console.log("This is the selectd user table::", user_input);
    var job_id_selected = user_input.getAttribute("job_id");
    var job_name_selected = user_input.getAttribute("job_name");
    console.log("This is the table selected:::", job_id_selected);
    console.log("Setting current table here:::");

    let jobs = JSON.parse(sessionStorage["all_jobs"]);
    let current_job = jobs.find((job) => job.job_id == job_id_selected);
    console.log("The current job:", current_job);
    if (current_job) {
      sessionStorage["current_job"] = JSON.stringify(current_job);
    }

    sessionStorage["current_table"] = JSON.stringify({
      table_id: job_id_selected,
      table_name: job_name_selected,
    });
    new PageContents().changePage("/tables");
  }
}


export { CopyLinks, UploadJDCVTopBar, TablesPageComponents };
if (typeof window !== 'undefined') {
  window.CopyLinks = CopyLinks;
  window.UploadJDCVTopBar = UploadJDCVTopBar;
  window.TablesPageComponents = TablesPageComponents;
}
